export const state = () => ({
  userInView: null,
});
